import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class ServicioBuscarGeoCode{
	
	constructor (private http:Http){}

	getGeocode(direccionBuscada:string) {
		let apiUrl ='https://maps.googleapis.com/maps/api/geocode/json?';
		let direccion = 'address=' + direccionBuscada;
		let key = '&key=AIzaSyC8X6Yg0NULOzyG8Z93WKxabJvLix9nPw4';
		return this.http.get(apiUrl + direccion + key)
        	            .map((res:Response) => res.json())
        	            .catch((error:any) => Observable.throw(error.json().error || 'Server error'));
	}
	  
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/geocoding.service.ts